import React from "react";
import AuthInterceptor from "../../interceptors/authInterceptor.jsx";
import Layout from "../../components/layout/UserLayout.jsx";

function Compras(props) {
  return (
    <Layout>
      <AuthInterceptor>
        <div className="mx-20 bg-green-500 text-3xl text-white">Compras</div>;
      </AuthInterceptor>
    </Layout>
  );
}

export default Compras;
